import { useEffect, useState } from 'react'
import { isNativePlatform } from '../lib/platform'

export function useNetworkStatus(): { online: boolean } {
  const [online, setOnline] = useState(true)

  useEffect(() => {
    let cleanup: (() => void) | undefined

    if (isNativePlatform()) {
      // Native: use Capacitor Network plugin
      import('@capacitor/network').then(({ Network }) => {
        Network.getStatus().then((s) => setOnline(s.connected))

        const listenerPromise = Network.addListener('networkStatusChange', (status) => {
          setOnline(status.connected)
        })

        cleanup = () => {
          listenerPromise.then((l) => l.remove()).catch(() => {})
        }
      }).catch(() => {
        // Fallback to browser events if native plugin fails
        setOnline(navigator.onLine)
      })
    } else {
      // Browser: use standard Web API
      setOnline(navigator.onLine)

      const handleOnline = () => setOnline(true)
      const handleOffline = () => setOnline(false)

      window.addEventListener('online', handleOnline)
      window.addEventListener('offline', handleOffline)

      cleanup = () => {
        window.removeEventListener('online', handleOnline)
        window.removeEventListener('offline', handleOffline)
      }
    }

    return () => cleanup?.()
  }, [])

  return { online }
}
